/* eslint-disable no-shadow */
import React, { useContext } from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import {
  FREEZE_MARKET,
  UPDATE_FREEZE_MARKET,
} from 'pages/ApplicationUI/ApplicationUIGraphQL';
import { authContext } from 'contexts/AuthContext';
import { freezeMarketValidation } from 'pages/ApplicationUI/constant';
import MarketFreezeDetailForm from './components/MarketFreezeDetailForm';

const currentDateAndTime = new Date();
const MarketFreezeDetail = ({ refetch, drawerToggle, initialValues }) => {
  const { auth } = useContext(authContext);
  const [freezeMarket] = useMutation(FREEZE_MARKET, {
    onCompleted: ({ freezeMarket }) => {
      toast.success(freezeMarket);
      drawerToggle();
      refetch();
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
      drawerToggle();
    },
  });

  const [updateFreezeMarket] = useMutation(UPDATE_FREEZE_MARKET, {
    onCompleted: ({ updateFreezeMarket }) => {
      toast.success(updateFreezeMarket);
      drawerToggle();
      refetch();
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
      drawerToggle();
    },
  });

  const handleSubmit = async (values) => {
    if (initialValues?.freezeStatus === true) {
      try {
        await updateFreezeMarket({
          variables: {
            applicationFreezeInputDTO: {
              id: values?.id,
              freezeStatus: false,
              applicationFreezeDetails: {
                id: values.applicationFreezeDetails?.id,
                freezeReason: values.applicationFreezeDetails?.freezeReason,
                freezeTimestamp: Date.parse(currentDateAndTime),
                createdBy: values.applicationFreezeDetails?.createdBy?.id,
                unfreezeTimestamp: Date.parse(currentDateAndTime),
                lastModifiedBy: auth?.data?.userId,
              },
            },
          },
        });
      } catch (err) {
        toast.error(err);
      }
    } else {
      try {
        await freezeMarket({
          variables: {
            applicationFreezeInputDTO: {
              freezeStatus: true,
              applicationFreezeDetails: {
                freezeTimestamp: Date.parse(currentDateAndTime),
                unfreezeTimestamp: null,
                freezeReason: values?.freezeReason,
                createdBy: auth?.data?.userId,
                lastModifiedBy: auth?.data?.userId,
              },
            },
          },
        });
      } catch (err) {
        toast.error(err);
      }
    }
  };

  return (
    <Formik
      initialValues={{ ...initialValues }}
      validationSchema={freezeMarketValidation}
      enableReinitialize
      onSubmit={handleSubmit}
      children={(props) => {
        return (
          <MarketFreezeDetailForm
            {...props}
            freezeStatus={initialValues?.freezeStatus}
          />
        );
      }}
    />
  );
};

export default MarketFreezeDetail;
